export default "__VITE_ASSET__C9WYCocC__"